import { render } from "./EventDetails.vue?vue&type=template&id=fd8fad0a"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script